import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { observer } from "mobx-react";
import styled from "styled-components";
import { IconButton, Tooltip } from "@material-ui/core";
import CommentsPopper from "./CommentsPopper";
import HistoryPopup from "./HistoryPopup";
import { RestorePage } from "@material-ui/icons";
import ChooseDonor from "./ChooseDonor";

class UserEventsRenderer extends Component {
  constructor(props) {
    super(props);
    this.getActionButton = this.getActionButton.bind(this);
    this.getRestoreIcon = this.getRestoreIcon.bind(this);
  }

  getRestoreIcon() {
    if (this.props.store.rowsWithRestoreIcon[this.props.data.row_id]) {
      return (
        <Tooltip title="Restore Record">
          <IconButton onClick={() => this.props.store.handleRestore(this.props.data.row_id)}>
            <RestorePage />
          </IconButton>
        </Tooltip>
      );
    }
    return null;
  }

  getActionButton( isEnabled, action, event, index, onClick) {
    if( !isEnabled && action == "hide") {
      return null;
    }
    var isButtonDisabled, isLoading;
    isButtonDisabled = isLoading = this.props.store?.executingEvents[
      this.props.data.row_id
    ]?.includes(event.id)
      ? true
      : false;
    if( !isEnabled && action == "disable") {
        isButtonDisabled = true;
    }
    let query = "";

    if (isButtonDisabled && typeof event.criteria == "string") {
      query = this.props.store.parseQueryForTooltip(event);
    }

    return (
      <Tooltip title={isButtonDisabled ? `This action is disabled due to this condition : ${query}`:""}>
          <ButtonWrappperDiv>
            <StyledButton
              key={index}
              size="small"
              className="muiTrigger margin-2"
              variant="outlined"
              onClick={onClick}
              disabled={isButtonDisabled}
            >
              <StyledButtonTextDiv
                disabled={isButtonDisabled}
                className={isButtonDisabled ? "" : "triggerBtnForTooltip"}
              >
                {event.label}
              </StyledButtonTextDiv>
              {isLoading && <CircularProgress size={18} color="inherit" />}
            </StyledButton>
          </ButtonWrappperDiv>
      </Tooltip>
    );
  }
  render() {
    return (
      <StyledDiv
        height={this.props.node.rowHeight}
      >
        {this.props.store?.listConfig?.list?.is_log_sheet == 1 && this.getRestoreIcon()}
        {this.props.store?.listConfig?.list?.is_log_sheet != 1 && <HistoryPopup data={this.props} />}
        {!this.props.store.isSubsheet && <CommentsPopper data={this.props} />}
        {(window.LOGGED_IN_USER.domain == "heysample" && this.props.store?.listConfig?.list.id == '59289877') && <ChooseDonor donorProps={this.props} />}
        {this.props.store.userEvents.map(
          (event, index) =>
          event.position.split(",").includes("column") &&
            this.getActionButton(this?.props?.data?.["is_event_" + event.id + "_disabled"] == "0", event.criteria_action, event, index, async () => {
              try {
                await window.appStore.notificationStore.confirm({
                  title: <>Confirmation</>,
                  description: (
                    <>
                      Are you sure you want to perform this action {event.name}
                    </>
                  ),
                });
                if (
                  this.props.data.row_id in this.props.store.executingEvents
                ) {
                  this.props.store.executingEvents[this.props.data.row_id].push(
                    event.id
                  );
                } else {
                  this.props.store.executingEvents[this.props.data.row_id] = [];
                  this.props.store.executingEvents[this.props.data.row_id].push(
                    event.id
                  );
                }
                await this.props.store.executeAction(
                  this.props.data.row_id,
                  this.props.data.uniqueId,
                  event.id
                );
                this.props.store.executingEvents[this.props.data.row_id].splice(
                  this.props.store.executingEvents[
                    this.props.data.row_id
                  ].indexOf(event.id),
                  1
                );
                if (
                  this.props.store.executingEvents[this.props.data.row_id]
                    .length == 0
                ) {
                  delete this.props.store.executingEvents[
                    this.props.data.row_id
                  ];
                }
              } catch (e) {
                console.log(e);
              }
            })
        )}
      </StyledDiv>
    );
  }
}
export default observer(UserEventsRenderer);

const StyledButton = styled(Button)`
  width: 100%;
  text-transform: uppercase !important;
  background-color: white;
  &:hover {
    background-color: #f6f1f1;
    border: 1px solid #black;
    color:black;
  }
  border : ${props => (props.disabled ? "1px solid rgba(0, 0, 0, 0.20)" : "1px solid rgba(0, 0, 0, 0.30)")};
`; 

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-height: ${(props) => props.height}px;
  align-content: center;
  justify-content: center;
  padding: 7px 3px;
  line-height: 10px;
`;

const StyledButtonTextDiv = styled.div`
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  color : ${props => (props.disabled ? "rgba(0, 0, 0, 0.20)" : "black")};
`;

const ButtonWrappperDiv = styled.div`
  overflow: hidden;
  padding: 2px;
`;
